import { render, staticRenderFns } from "./FileManagerSidebar.vue?vue&type=template&id=66e57ceb"
import script from "./FileManagerSidebar.vue?vue&type=script&lang=js"
export * from "./FileManagerSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports